// Types
import { ClinicType } from "src/services/clinics/types";

// True when the clinic is licensed for at least one kind of simulation, which
// is what decides whether the simulation tabs and settings show at all.
export const canUseAnySimulations = (
  licensing: ClinicType["licensing"] | undefined
): boolean =>
  Boolean(
    licensing?.canUseIOLSimulations ||
      licensing?.canUseProgressiveSimulations ||
      licensing?.canUseDryEyeSimulations
  );
